import { render, staticRenderFns } from "./ListUnitTable.vue?vue&type=template&id=3127c198&scoped=true&"
import script from "./ListUnitTable.vue?vue&type=script&lang=ts&"
export * from "./ListUnitTable.vue?vue&type=script&lang=ts&"
import style0 from "./ListUnitTable.vue?vue&type=style&index=0&id=3127c198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127c198",
  null
  
)

export default component.exports